import axios, { AxiosError } from 'axios'
import { ActionWithPayload, AppDispatch, RootState } from '../store'

const PROMO_CODE_SEND_REQUEST = 'PROMO_CODE_SEND_REQUEST'
const PROMO_CODE_SEND_SUCCESS = 'PROMO_CODE_SEND_SUCCESS'
const PROMO_CODE_SEND_ERROR = 'PROMO_CODE_SEND_ERROR'
export const PROMO_CODE_SEND_RESET = 'PROMO_CODE_SEND_RESET'

interface PromoCodeSendRequestAction {
  type: typeof PROMO_CODE_SEND_REQUEST
}

interface PromoCodeSendSuccessAction {
  type: typeof PROMO_CODE_SEND_SUCCESS
  payload: boolean
}

interface PromoCodeSendErrorAction {
  type: typeof PROMO_CODE_SEND_ERROR
  payload: string
}

type PromoCodeSendActionTypes =
  | PromoCodeSendRequestAction
  | PromoCodeSendSuccessAction
  | PromoCodeSendErrorAction

export const sendPromoCodeEmail =
  (selectedCode: PromoCode, selectedProjects: Project[]) =>
  async (dispatch: AppDispatch, getState: () => RootState) => {
    try {
      dispatch({
        type: PROMO_CODE_SEND_REQUEST,
      })

      const {
        userLogin: { userInfo },
      } = getState()
      const token = (userInfo as User).token

      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }

      const { data } = await axios.post(
        `/api/promoCodes/send`,
        { selectedCode, selectedProjects },
        config
      )

      dispatch({
        type: PROMO_CODE_SEND_SUCCESS,
        payload: data,
      })
    } catch (err: unknown) {
      let errorMessage = 'An unexpected error occurred'

      if (axios.isAxiosError(err)) {
        const error = err as AxiosError

        if (error.response && error.response.data) {
          errorMessage = (error.response.data as { message: string }).message
        } else {
          errorMessage = error.message
        }
      } else if (err instanceof Error) {
        // This will be true for any instance of Error
        errorMessage = err.message
      }

      dispatch({
        type: PROMO_CODE_SEND_ERROR,
        payload: errorMessage,
      })
    }
  }

interface InitialState {
  error: string
  loading: boolean
  success: boolean
}

const initialState: InitialState = {
  error: '',
  loading: false,
  success: false,
}

export const promoCodeSendReducer = (
  state = initialState,
  action: ActionWithPayload<PromoCodeSendActionTypes>
) => {
  switch (action.type) {
    case PROMO_CODE_SEND_REQUEST:
      return {
        ...state,
        error: '',
        loading: true,
        success: false,
      }
    case PROMO_CODE_SEND_SUCCESS:
      return {
        ...state,
        error: '',
        success: true,
        loading: false,
      }
    case PROMO_CODE_SEND_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
        success: false,
      }
    case PROMO_CODE_SEND_RESET:
      return {
        ...initialState,
      }
    default:
      return state
  }
}
